import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { byteSize, Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBaiViet } from 'app/shared/model/bai-viet.model';
import { searchEntities, getEntities } from './bai-viet.reducer';

export const BaiViet = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const baiVietList = useAppSelector(state => state.baiViet.entities);
  const loading = useAppSelector(state => state.baiViet.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bai-viet-heading" data-cy="BaiVietHeading">
        <Translate contentKey="xtdtApp.baiViet.home.title">Bai Viets</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.baiViet.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/bai-viet/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.baiViet.home.createLabel">Create new Bai Viet</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.baiViet.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {baiVietList && baiVietList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.tieuDe">Tieu De</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.moTa">Mo Ta</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.anhDaiDien">Anh Dai Dien</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.noiDung">Noi Dung</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.diaPhuong">Dia Phuong</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.baiViet.loaiQuyHoach">Loai Quy Hoach</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {baiVietList.map((baiViet, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/bai-viet/${baiViet.id}`} color="link" size="sm">
                      {baiViet.id}
                    </Button>
                  </td>
                  <td>{baiViet.tieuDe}</td>
                  <td>{baiViet.moTa}</td>
                  <td>{baiViet.anhDaiDien}</td>
                  <td>{baiViet.noiDung}</td>
                  <td>{baiViet.diaPhuong ? <Link to={`/don-vi-hanh-chinh/${baiViet.diaPhuong.id}`}>{baiViet.diaPhuong.id}</Link> : ''}</td>
                  <td>
                    {baiViet.loaiQuyHoach ? <Link to={`/loai-quy-hoach/${baiViet.loaiQuyHoach.id}`}>{baiViet.loaiQuyHoach.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/bai-viet/${baiViet.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/bai-viet/${baiViet.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/bai-viet/${baiViet.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.baiViet.home.notFound">No Bai Viets found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default BaiViet;
